












import { Component, Vue, Watch } from 'vue-property-decorator'
import List from '@/components/judge/judgeList.vue'
import Tab from '@/components/tab.vue'
import SidebarItem from '@/components/sidebarItem.vue'
import { list } from '@/api/task/judge'
import { PAGINATION_PARAM, taskStatusList } from '@/global/constants'
import { goTop } from '@/global/utils'

@Component({
  components: {
    SidebarItem,
    List,
    Tab
  }
})
export default class Task extends Vue {
  private tabsStatuesList: object[] = taskStatusList
  private dataList: object = []
  private loading: boolean = false
  private total: number = 0
  private data: object = {
    check_pass: '',
    ...PAGINATION_PARAM
  }
  private created() {
    this.getList(this.data)
  }
  // 获取列表数据
  private async getList(params) {
    this.loading = true
    try {
      const data: any = await list(params)
      this.$nextTick(() => {
        this.dataList = data ? data.rows : []
        this.total = data ? data.total : 0
      })
    } catch (err) {
      console.log(err)
    }
    this.loading = false
    goTop()
  }
  // status 切换
  private changeStatus(status) {
    status = status === '2' ? '' : status
    this.data = Object.assign(this.data, { check_pass: status })
    this.getList(this.data)
  }
  // page切换
  public changePage(data) {
    this.data = Object.assign(this.data, { page: data })
    this.getList(this.data)
  }
}
